import { Modal } from 'antd'
import styled from 'styled-components'

const StyledUnknownWordsModal = styled(Modal)`
  overflow-y: initial;
  top: 20px;

  .ant-modal-body {
    background-color: #f3f3f3;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: calc(100vh - 65px - 40px);
  }

  .ant-modal-header {
    background-color: #f3f3f3;
    border-bottom: none;
  }
`

export default StyledUnknownWordsModal
